import React, { createContext, useContext, useEffect, useState } from "react";

interface SnowOverlayContextType {
  enabled: boolean;
  toggle: () => void;
}

const SnowOverlayContext = createContext<SnowOverlayContextType | undefined>(
  undefined
);

export const SnowOverlayProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [enabled, setEnabled] = useState<boolean>(() => {
    const stored = localStorage.getItem("snowOverlayEnabled");
    return stored ? JSON.parse(stored) : true;
  });

  useEffect(() => {
    localStorage.setItem("snowOverlayEnabled", JSON.stringify(enabled));
  }, [enabled]);

  const toggle = () => setEnabled((prev) => !prev);

  return (
    <SnowOverlayContext.Provider value={{ enabled, toggle }}>
      {children}
    </SnowOverlayContext.Provider>
  );
};

export const useSnowOverlay = () => {
  const context = useContext(SnowOverlayContext);
  if (!context)
    throw new Error("useSnowOverlay must be used within a SnowOverlayProvider");
  return context;
};
